module.exports = __webpack_public_path__ + "media/images/favicons/icon-24x24-65978ee5d959123810bc7d10f2bc6568.png";